<template>
  <div class="import-data">
    <input
      ref="fileInput"
      class="hidden"
      type="file"
      v-on:change="onFileChanged"
      accept=".csv,.txt"
    />
    <grafokett-button
      class="button big primary white"
      @click="openFileSelection"
      >Import data</grafokett-button
    >
    <modal
      v-if="importResult.show"
      :type="importResult.type"
      :heading="importResult.heading"
      :description="importResult.description"
      @close="importResult.show = false"
    />
  </div>
</template>

<script>
import GrafokettButton from "./forms/Button";
import Modal from "./Modal";
export default {
  components: {
    GrafokettButton,
    Modal,
  },
  data: () => ({
    importResult: {
      show: false,
      type: "success",
      heading: "Success",
      description:
        "Your data have been queued for import and will shortly be available",
    },
  }),
  methods: {
    async onFileChanged(event) {
      let files = event.target.files;
      let result = [];
      for (let i = 0; i < files.length; i++) {
        result.push(files.item(i));
      }
      // filesAdded
      const file = result[0];
      if (!file) {
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      await this.importData(formData);
    },
    openFileSelection() {
      this.$refs.fileInput.click();
    },
    async importData(file) {
      this.loading = true;
      try {
        await this.$store.$importService.post("/api/import", file, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${file._boundary}`,
          },
        });
      } catch (e) {
        this.importResult.type = "error";
        this.importResult.heading = "Error";
        this.importResult.description =
          "Something went wrong with importing your order (s). Please verify file formatting";
        console.error(e);
      } finally {
        this.loading = false;
        this.importResult.show = true;
      }
    },
  },
};
</script>
